import { render, staticRenderFns } from "./ListSettings.vue?vue&type=template&id=53293a38&scoped=true"
import script from "./ListSettings.vue?vue&type=script&lang=ts"
export * from "./ListSettings.vue?vue&type=script&lang=ts"
import style0 from "./ListSettings.vue?vue&type=style&index=0&id=53293a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53293a38",
  null
  
)

export default component.exports